<template>
  <div>
    <div style="position: relative">
      <page-header
        class="mb-6"
        :header-title="$t('IMPORT_WIZARD.STEP_3.TITLE')"
        :header-content="$t('IMPORT_WIZARD.STEP_3.DESC')"
      />

      <div class="row modal-content">
        <div class="medium-12 columns">
          <label>
            {{ $t('IMPORT_WIZARD.STEP_3.LABEL') }}
            <select v-model="selectedInboxId" @change="onChangeInbox($event)">
              <option v-for="item in inboxes" :key="item.name" :value="item.id">
                {{ item.name }}
              </option>
            </select>
            <span v-if="error" class="text-red-500">
              {{ $t('IMPORT_WIZARD.STEP_3.ERROR') }}
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageHeader from 'dashboard/routes/dashboard/settings/SettingsSubPageHeader.vue';

export default {
  components: { PageHeader },
  data() {
    return {
      selectedInboxId: null,
      error: '',
    };
  },
  computed: {
    ...mapGetters({
      inboxes: 'inboxes/getInboxes',
    }),
  },
  methods: {
    onChangeInbox() {
      this.$store.commit('importWizard/SET_INBOX', this.selectedInboxId);
    },
  },
};
</script>

<style scoped lang="scss"></style>
